<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.74163 16.0161C6.18934 16.0161 5.74163 15.5684 5.74163 15.0161V11.1979C5.74163 10.6456 5.29391 10.1979 4.74163 10.1979H1C0.447716 10.1979 0 9.75022 0 9.19793V6.8343C0 6.28201 0.447715 5.83429 1 5.83429H4.74163C5.29391 5.83429 5.74163 5.38658 5.74163 4.83429V1.01611C5.74163 0.46383 6.18934 0.0161133 6.74163 0.0161133H9.25837C9.81066 0.0161133 10.2584 0.463829 10.2584 1.01611V4.83429C10.2584 5.38658 10.7061 5.83429 11.2584 5.83429H15C15.5523 5.83429 16 6.28201 16 6.83429V9.19793C16 9.75021 15.5523 10.1979 15 10.1979H11.2584C10.7061 10.1979 10.2584 10.6456 10.2584 11.1979V15.0161C10.2584 15.5684 9.81066 16.0161 9.25837 16.0161H6.74163Z"
      fill="currentColor"
    />
  </svg>
</template>